import React from 'react';

const CarreFlecheSortante = ({width = 20, height = 20, couleur = "#FF9436"}) => (
<svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 13 13" fill="none">
    <path
        d="M5.96875 2.32422L10.6058 2.32422L10.6058 6.97171"
        fill={couleur}/>
    <path
        d="M5.96875 2.32422L10.6058 2.32422L10.6058 6.97171"
        stroke={couleur} strokeWidth="1.5"/>
    <line y1="-0.75" x2="6.4794" y2="-0.75"
          transform="matrix(-0.70631 0.707903 -0.70631 -0.707903 9.9834 1.9707)"
          stroke={couleur} strokeWidth="1.5"/>
    <path
        d="M11.0254 8.81725V12L1.02539 12V2.00006L4.0255 2"
        stroke={couleur} strokeWidth="1.5"/>
</svg>
);

export default CarreFlecheSortante;
